module.exports = __webpack_public_path__ + "img/prevIcon.9fb561c4.svg";